import { Container, Heading, Box, Button, Text, Center, Flex } from '@chakra-ui/react';
import React from 'react';
import { BiCalendarPlus } from 'react-icons/bi';
import { FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const VideoGroupTop: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxW="container.sm" mt={10}>
      <Box textAlign="center">
        <Heading as="h1" size="lg" mb={10}>
          グループ通話
        </Heading>
        <Flex justify="center" gap={8} mt={8}>
          <Box>
            <Button
              as={Center}
              borderRadius="full"
              w="180px"
              h="180px"
              bg="#7AB547"
              color="white"
              _hover={{ bg: "#689a3d" }}
              onClick={() => navigate('/video/group')}
              flexDirection="column"
              p={6}
              cursor="pointer"
            >
              <Text fontSize="md" mb={2}>グループ通話に</Text>
              <Text fontSize="3xl" fontWeight="bold" mb={4}>参加する</Text>
              <FaUsers size="40px" />
            </Button>
          </Box>
          <Box>
            <Button
              as={Center}
              borderRadius="full"
              w="180px"
              h="180px"
              bg="#7AB547"
              color="white"
              _hover={{ bg: "#689a3d" }}
              onClick={() => navigate('/video/group/reservation/create')}
              flexDirection="column"
              p={6}
              cursor="pointer"
            >
              <Text fontSize="md" mb={2}>グループ通話を</Text>
              <Text fontSize="3xl" fontWeight="bold" mb={4}>予約する</Text>
              <BiCalendarPlus size="40px" />
            </Button>
          </Box>
        </Flex>
      </Box>
    </Container>
  );
};

export default VideoGroupTop; 